import React, { useState, useEffect } from 'react'
import Tabla from "./Components/Tabla/Tabla";
export default function TablaPY(props) {
  const SetData = props.set;
  const [tabla, setTabla] = useState(
    [
      {
        border: 1,
        Header: [
          {
            Title: 'Tabla de Valores',
            col: [
            ]
          }
        ],
        Body: [
          {
            col: [
            ]
          }
        ]
      }
    ]
  )

  useEffect(() => {
    function Paste(event) {
      event.preventDefault();
      let paste = (event.clipboardData || window.clipboardData).getData("text");
      let rows = paste.match(/[0-9a-zA-Z.\t\r]+(?=\r\n)/gm);
      let data = []
      let letra = ['A', 'B']
      let countl = 0;
      rows.forEach(row => {
        let arr = row.split(/\t/)
        arr = arr.map((cell, icell) => {
          if (icell === 0) {
            if (cell !== '' && countl === 0) {
              let prom = (parseFloat(arr[icell + 1]) + parseFloat(cell)) / 2
              return prom
            } else {
              return ''
            }
          } else {
            if (cell !== '') {
              return parseFloat(cell)
            } else {
              return ''
            }
          }
        })
        arr = arr.filter((_, ind) => ind !== 1)
        arr.splice(1, 0, 0);
        arr.splice(1, 0, letra[countl]);
        data.push(arr)
        countl = countl === 0 ? 1 : 0;
      });

      setTabla(v => v.map(t => ({
        ...t,
        Header: t.Header.map(h => ({
          ...h,
          col: [data[0].map((_, ind) => {
            switch (ind) {
              case 0:
                return 'Penetración Bajo Fondo Marino (m)'
              case 1:
                return ''
              default:
                return ind - 1
            }
          })]
        })
        ),
        Body: t.Body.map(b => ({
          ...b,
          col: data
        })
        )
      }))
      );

      SetData(d => ({
        ...d,
        data: data
      }))

    }
    document.addEventListener('paste', Paste);
    return () => {
      document.removeEventListener('pate', Paste)
    }
  }, [setTabla, SetData])

  function onClick(e, d) {
    e.preventDefault();
    setTabla(v => v.map(t => ({
      ...t,
      Header: t.Header.map(h => ({
        ...h,
        Title: 'Cotizaciones'
      })
      )
    }))
    );
    console.log(d)
  }

  return (
    <Tabla tablas={[tabla, setTabla]} onClick={onClick} />
  )
}